import VueI18n from "vue-i18n";

import { DayCondition } from "../DayCondition";
import { PeriodConditionsTypeEnum } from "../types";

export class DayOfMonth extends DayCondition {
  type: PeriodConditionsTypeEnum = PeriodConditionsTypeEnum.DayOfMonth;

  getBeautifiedValues(i18n: VueI18n) {
    return i18n.t('period_conditions_day_selected_days', [ this.values.join(', ') ]).toString()
  }
}
